import React from 'react';
import { Link } from 'react-router-dom';
import { SmartBlock, SmartSpace, SmartButton } from '../../SmartComponent';
import { useTranslation } from 'react-i18next';


export default function Prepack(): JSX.Element {
  const { t } = useTranslation()
  return (
    <SmartBlock>
      <SmartSpace>
        <Link to="/smart/unpack/check-status">
          <SmartButton isComingSoon>
            {t('smart.prepack.unpack.checkUnpackStatus.title')}
          </SmartButton>
        </Link>
        <Link to="/smart/unpack/item">
          <SmartButton>
            {t('smart.prepack.unpack.unpackItem.title')}
          </SmartButton>
        </Link>
        <Link to="/smart/unpack/adjust">
          <SmartButton>
            {t('smart.prepack.unpack.adjust.title')}
          </SmartButton>
        </Link>
      </SmartSpace>
    </SmartBlock>
  );
}
